import React from 'react';
import {withStyles} from '@material-ui/core/styles/index';
import {withRouter} from 'react-router-dom';
import classNames from 'classnames';
import {Typography} from '@material-ui/core';
import FuseNavBadge from '../@fuse/components/FuseNavigation/FuseNavBadge';
import config from '../constants/app/config';


const styles = theme => ({
    root: {
        display: 'flex',
        alignItems: 'center'
    },
    logo: {},
    logoIcon: {
        width: 38,
        height: 38
    }
});

function MainNavbarHeader({classes}) {

    let badge = {
        title: config.version,
    }

    return (
        <div className={classes.root}>
            <div className={classNames(classes.logo, "flex items-center")}>
                <img className={classes.logoIcon}
                     src="https://res.cloudinary.com/uecare/image/upload/v1524451999/official/appLogo_3x.png"
                     alt="logo"/>
                <Typography className="text-20 ml-8 font-light logo-text">{`管理中心`}</Typography>
                <FuseNavBadge className="ml-8 mr-4" badge={badge}/>

            </div>
        </div>
    );
};

export default withStyles(styles, {withTheme: true})(withRouter(MainNavbarHeader));



// WEBPACK FOOTER //
// ./src/main/MainNavbarHeader.js